var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.76135 0.92705C7.0607 0.00573921 8.36411 0.00573969 8.66346 0.92705L9.73303 4.21885C9.8669 4.63087 10.2509 4.90983 10.6841 4.90983H14.1453C15.114 4.90983 15.5168 6.14945 14.7331 6.71885L11.9329 8.75329C11.5824 9.00793 11.4358 9.4593 11.5696 9.87132L12.6392 13.1631C12.9386 14.0844 11.8841 14.8506 11.1004 14.2812L8.30019 12.2467C7.9497 11.9921 7.4751 11.9921 7.12462 12.2467L4.32445 14.2812C3.54073 14.8506 2.48625 14.0844 2.78561 13.1631L3.85518 9.87132C3.98905 9.4593 3.84239 9.00793 3.4919 8.75329L0.691735 6.71885C-0.0919785 6.14945 0.310797 4.90983 1.27952 4.90983H4.74072C5.17395 4.90983 5.5579 4.63087 5.69178 4.21885L6.76135 0.92705Z",
    fill: "#E99550"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.12a6b231edf81ef91d2f3e673616e326.svg";
export { ForwardRef as ReactComponent };